import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { newsList } from "@/mocks/news";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-14 border-t border-primary-900 bg-primary-950">
      <div className="mx-auto w-full max-w-portal px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500">
                <span className="font-heading text-lg font-black text-secondary-200">三</span>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-background-50">三级片</span>
                <span className="mt-1 text-[9px] uppercase tracking-[0.28em] text-primary-300">
                  Category III Archive
                </span>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              一个专注三级片影片资料与行业资讯的影视档案馆。整理经典与近期作品信息，帮助观众在观看之前先了解作品本身。
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-secondary-500">影片分类</p>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((category) => (
                <li key={category.key}>
                  <Link
                    to={`/category/${category.key}`}
                    className="cursor-pointer text-sm text-background-200 transition-colors hover:text-secondary-300"
                  >
                    {category.name}三级片电影大全
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-secondary-500">最新资讯</p>
            <ul className="mt-4 flex flex-col gap-2.5">
              {newsList.slice(0, 3).map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/news/${item.id}`}
                    className="line-clamp-2 cursor-pointer text-sm leading-relaxed text-background-200 transition-colors hover:text-secondary-300"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-secondary-500">站点说明</p>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-file-list-3-line mt-0.5 text-secondary-500" />
                所有影片与人物均为虚构示例
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-forbid-2-line mt-0.5 text-secondary-500" />
                不提供在线播放、下载或付费服务
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-secondary-500" />
                内容仅面向成年观众，请理性浏览
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 三级片 · 影视资料门户（演示站点）</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/" className="cursor-pointer hover:text-secondary-300">
              首页
            </Link>
            <Link to="/news" className="cursor-pointer hover:text-secondary-300">
              资讯
            </Link>
            <Link to="/category/drama" className="cursor-pointer hover:text-secondary-300">
              分类浏览
            </Link>
            <span className="text-primary-400">本站不提供任何受限影音功能</span>
          </p>
        </div>
      </div>
    </footer>
  );
}